module.exports = __webpack_public_path__ + "img/Country2-2.5f28fee9.png";